import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getBetPattern=(token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_BET_PATTERN_START,
    })
    const options={
        url:`${api}/betpatterns/summary`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_BET_PATTERN_SUCCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_BET_PATTERN_FAIL,
                payload:getMessage(error)
            }))
}